import { render, staticRenderFns } from "./Aid.vue?vue&type=template&id=4c6e80e4"
import script from "./Aid.vue?vue&type=script&lang=js"
export * from "./Aid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports